angular.module('cvsApp').service('retrieveFormOfPaymentService',['networkService','xdrService', 'configManager', 'retrieveFormOfPaymentModel','cvsAppData', function (NS, XS, CM, RFPM,CAD) {

	function retrieveFormOfPaymentService (){
		this.retrieveFormOfPaymentdata = function(callBackSuccess,guestTokenID){
			//get url
			//var tokenId=cvsUtility.queryMap.tokenId?cvsUtility.queryMap.tokenId:guestTokenID;
			var tid, tokenType;
			try{
				tid = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tid = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
			var url = CM.getApiUrl('GET_FORM_OF_PAYMENT', tid, tokenType);
			if(url === "URL_ERROR"){

			}else{
				var request = {url:url,
							header:{"Content-Type":"application/xml"},
							data:getRequestBody(guestTokenID),
							onSuccess:callBackSuccess
						}
				if (cvsUtility.getIEVersion() <= 9) {
					XS.makeRequest(url, getRequestBody(), xdrSuccess);

					function xdrSuccess (data) {
						RFPM.setResponse(data);
						callBackSuccess(RFPM.getResponse());
					}
				}
				else {
					var promise = NS.post(request);
					promise.then(function(data, c, d){

						RFPM.setResponse(data.data);
						callBackSuccess(RFPM.getResponse());

						//send message to parent
						//cvsUtility.sendPostMessage("SESSION-ALIVE","retrieveFormOfPayment");

					}, function(reason){
						callBackSuccess(NS.httpError(reason));
					});
				}
			}

		}

    function convertToTwoDigit (number) {
      return (number < 10) ? '0' + number : number;
    }

    var date = new Date();
    var currentYear = date.getFullYear();
    var currentMonth =convertToTwoDigit(date.getMonth() + 1);
    var currentDay = convertToTwoDigit(date.getDate());

    var hour = convertToTwoDigit(date.getHours());
    var minute = convertToTwoDigit(date.getMinutes());
    var second = convertToTwoDigit(date.getSeconds());

    var timeStamp = currentYear + '-' + currentMonth + '-' + currentDay + 'T' + hour
      + ':' + minute + ':' + second;

		var getRequestBody = function(guestTokenID){
				var date = new Date();
			var tid, tokenType;
			try{
				tid = CAD.getTokenId() ? CAD.getTokenId() : (guestTokenID || cvsUtility.queryMap.tokenId);
				tokenType = CAD.getTokenType() ? CAD.getTokenType() : ((guestTokenID) ? 'Guest' : 'Login');
			}
			catch(ex){
				tid = guestTokenID || cvsUtility.queryMap.tokenId;
				tokenType = (guestTokenID) ? 'Guest' : 'Login';
			}
				var requestJson = {request:{
								tokenID:tid,
								tokenType:tokenType,
								apiKey:cvsUtility.queryMap.apikey,
								timestamp:timeStamp}}

				return cvsUtility.JSONToXml(requestJson);
			}
	}

	return new retrieveFormOfPaymentService();
}]);
